import { render, staticRenderFns } from "./ReviewStatus.vue?vue&type=template&id=35ca8556&scoped=true"
import script from "./ReviewStatus.vue?vue&type=script&lang=js"
export * from "./ReviewStatus.vue?vue&type=script&lang=js"
import style0 from "./ReviewStatus.vue?vue&type=style&index=0&id=35ca8556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ca8556",
  null
  
)

export default component.exports